module.exports = __webpack_public_path__ + "img/卷轴.240eecaa.png";